/* Compare-at (strikethrough) price handling for product cards.
   Uses the data-compare / data-price / data-available attributes that snippets/price.liquid puts on each size option.

   1) When a shopper changes size, show or hide the sale price for that size. Runs after the size-switch
      handler in custom.js (setTimeout 0), so it has the final say on the price block.
   2) Card photo follows the selected size (uses data-image on each size option, when that size has its own photo).
   3) Product page: open the gallery on the photo of the active size (e.g. ?variant=... links, or when the first
      size is sold out). The theme's own code for this has a typo in its selector, so it never ran.
   4) Card links carry ?variant=<shown size>, so the product page opens on the size the card was showing.
   5) On cards (including cards drawn by the search & filter app), if the starting size has no sale but another
      IN-STOCK size does, start on that size instead. Sold-out sale sizes are skipped. Done once per card, so a
      shopper's own choice is never overridden. Uses a normal change event so the Add to Bag button stays in sync. */
(function () {
  if (window.hpComparePriceLoaded) return;
  window.hpComparePriceLoaded = true;

  var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  var SELECT = '.hp-variant-select__select';
  var CARD = '.card-wrapper, .usf-product-item, .grid__item, .slick-slide, .card-information';

  function num(el, attr) { return parseInt(el.getAttribute(attr), 10) || 0; }
  function isSale(opt) { return num(opt, 'data-compare') > num(opt, 'data-price'); }

  function applySale(select) {
    var opt = select.options[select.selectedIndex];
    if (!opt || !opt.hasAttribute('data-compare')) return; // other dropdowns: leave alone
    var wrap = select.closest('.price');
    if (!wrap) return;
    var onSale = isSale(opt);
    wrap.classList.toggle('price--on-sale', onSale);
    var strike = wrap.querySelector('.price__sale s.price-item');
    if (strike) strike.textContent = onSale ? fmt.format(num(opt, 'data-compare') / 100) : '';
  }

  function cardImage(select) {
    var n = select.parentElement;
    for (var i = 0; n && i < 12; i++, n = n.parentElement) {
      var img = n.querySelector('.media img');
      if (img) return img;
    }
    return null;
  }

  function applyImage(select) {
    var opt = select.options[select.selectedIndex];
    var base = opt && opt.getAttribute('data-image');
    if (!base || !select.closest(CARD)) return; // size has no photo of its own, or not a card
    var img = cardImage(select);
    if (!img || img.getAttribute('data-hp-img') === base) return;
    function w(n) { return base.replace(/width=\d+/, 'width=' + n); }
    img.setAttribute('data-hp-img', base);
    img.srcset = [360, 533, 720, 940, 1066].map(function (n) { return w(n) + ' ' + n + 'w'; }).join(', ');
    img.src = w(600);
  }

  function syncLinks(select) {
    var opt = select.options[select.selectedIndex];
    var id = opt && opt.value;
    var card = select.closest('.usf-product-item, .card-wrapper, .grid__item, .slick-slide');
    if (!id || !card) return;
    var links = card.querySelectorAll('a[href*="/products/"]');
    for (var j = 0; j < links.length; j++) {
      try {
        var u = new URL(links[j].getAttribute('href'), window.location.origin);
        if (u.searchParams.get('variant') !== id) {
          u.searchParams.set('variant', id);
          links[j].setAttribute('href', u.pathname + u.search + u.hash);
        }
      } catch (e) {}
    }
  }

  function startOnSaleSize(select) {
    if (select.getAttribute('data-hp-sale-init')) return;
    var opts = select.options;
    if (!opts.length || !opts[0].hasAttribute('data-compare')) return;
    if (!select.closest(CARD)) return; // cards only, never the product page
    select.setAttribute('data-hp-sale-init', '1');
    applyImage(select);
    syncLinks(select);
    if (isSale(opts[select.selectedIndex])) return;
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].getAttribute('data-available') === 'true' && isSale(opts[i])) {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  function scan(root) {
    var list = (root || document).querySelectorAll(SELECT);
    for (var i = 0; i < list.length; i++) startOnSaleSize(list[i]);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('hp-variant-select__select')) {
      setTimeout(function () { applySale(t); applyImage(t); syncLinks(t); }, 0);
    }
  });

  // Product page: show the active size's photo first in the gallery slider.
  function initPdpSlide() {
    var slider = document.getElementById('slider');
    var $ = window.jQuery;
    if (!slider || !$ || !$.fn || !$.fn.slick || !window.fetch) return;
    var input = document.querySelector('product-form input[name="id"]');
    var vid = new URLSearchParams(window.location.search).get('variant') || (input && input.value);
    if (!vid) return;
    fetch(window.location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(vid); })[0];
        var mid = v && v.featured_media && v.featured_media.id;
        if (!mid) return;
        var tries = 0;
        (function go() {
          var $s = $('#slider');
          if ($s.hasClass('slick-initialized')) {
            var li = slider.querySelector('.slick-slide:not(.slick-cloned)[data-media-id$="-' + mid + '"]');
            var idx = li ? parseInt(li.getAttribute('data-slick-index'), 10) : NaN;
            if (!isNaN(idx) && $s.slick('slickCurrentSlide') !== idx) $s.slick('slickGoTo', idx, true);
          } else if (++tries < 40) {
            setTimeout(go, 150);
          }
        })();
      })
      .catch(function () {});
  }

  var queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(document); });
  }
  function start() {
    initPdpSlide();
    scan(document);
    if (window.MutationObserver) {
      new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
    }
  }
  // Wait for the page to finish loading, so custom.js has registered its size-switch handler first.
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
